var _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAquilaAff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520 150",
    width: 520,
    height: 150,
    role: "img",
    "aria-label": "Aquila Asset Management",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 96,
    fontFamily: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
    fontSize: 96,
    fontWeight: 900,
    letterSpacing: 1,
    fill: "#111111"
  }, "AQUILA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 512,
    y: 134,
    textAnchor: "end",
    fontFamily: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 500,
    letterSpacing: 0.3,
    fill: "#4a86b8"
  }, "Asset Management.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAquilaAff);
export default __webpack_public_path__ + "static/media/aquila_aff.da431e2ed79505644793b4f8c690e16b.svg";
export { ForwardRef as ReactComponent };